import { SuperPacksClient } from '../types'

export const searchSuperPacks = (base: SuperPacksClient) => (data: { search: string }) =>
  base.requester.post('/search', data, { withCredentials: true })
